import {createAction, props} from "@ngrx/store";

/**
 * Calibration actions definitions
 *
 * Here goes all the actions that affects the calibration data, it stores, updates , retrieve and delete the
 * calibration data based on grid id
 */
export enum CalibrationActionTypes {
  addCalibrationData =  '[Calibration] Load Calibration Details',
  addCalibrationDataSuccess = '[Calibration] Load Calibration Details Success',
  addCalibrationDataFailure = '[Calibration] Load Calibration Details Failure',

}

export const addCalibrationData = createAction(CalibrationActionTypes.addCalibrationData, props<{ gridId: string }>());
export const addCalibrationDataSuccess = createAction(CalibrationActionTypes.addCalibrationDataSuccess,
  props<{ gridId: string; data: number }>());
export const addCalibrationDataFailure = createAction(CalibrationActionTypes.addCalibrationDataFailure,
  props<{error : Error}>());
